import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import VerifyCodeBtn from "../components/verifyCodeBtn";
import GoBackBtn from "../components/goBackBtn";
import Loading from "../components/loading";
import ErrorModal from "../components/errorModal";
import { checkPwd } from "../utilities/Utils";
import styles from "../styles/Home.module.scss";
import API from "../services/api";
import store from "store-js";
import { useTranslation } from "react-i18next";
import { useCookieState } from 'ahooks';

const location = "852";

/* Dummy Code Testing */
// const test_otp = "123456";

export default function ForgetPassword({ config, type }) {
  const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
  const api = new API(token);
  const CustomConfig = config;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [locationCode, setLocationCode] = useState(location);
  const [phoneNum, setPhoneNum] = useState();
  const [otp, setOtp] = useState();
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState();
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const [reset, setReset] = useState(false);

  const [invalidPhone, setInvalidPhone] = useState(false);
  const [invalidPhoneLength, setInvalidPhoneLength] = useState(true);
  const [invalidOtp, setInvalidOtp] = useState(false);
  const [invalidPwd, setInvalidPwd] = useState();
  const [matchPwd, setMatchPwd] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [isOTPloading, setIsOTPloading] = useState(false);
  const [count, setCount] = useState(0);
  const [timeoutID, setTimeoutID] = useState(null);

  const [errModalMsg, setErrModalMsg] = useState(null);
  const [consoleMsg, setConsoleMsg] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if the page is refreshed & getOTP was clicked
    // if (session) {
    if (store.get("otpCountDown")) {
      setCount(Number(store.get("otpCountDown")));
    }
    // }
    return () => {
      clearTimeout(window.otpTimeoutID);
    };
  }, []);

  useEffect(() => {
    if (locationCode && phoneNum) validateLocPhone(phoneNum);
  }, [locationCode, phoneNum]);

  useEffect(() => {
    if (!reset && invalidPhoneLength) setBtnDisabled(true);
  }, [invalidPhoneLength]);

  useEffect(() => {
    if (pwd) {
      let valid = checkPwd(pwd);
      valid ? setInvalidPwd(false) : setInvalidPwd(true);
      pwd === confirmPwd ? setMatchPwd(true) : setMatchPwd(false);
    }
  }, [pwd]);

  useEffect(() => {
    if (confirmPwd) {
      pwd === confirmPwd ? setMatchPwd(true) : setMatchPwd(false);
    }
  }, [confirmPwd]);

  useEffect(() => {
    if (reset) {
      invalidPwd || !matchPwd ? setBtnDisabled(true) : setBtnDisabled(false);
    } else {
      invalidPhone || invalidPhoneLength || invalidOtp
        ? setBtnDisabled(true)
        : setBtnDisabled(false);
    }
  }, [phoneNum, otp, pwd, confirmPwd, matchPwd, invalidPhoneLength]);

  // Verification code count down
  useEffect(() => {
    if (count !== 0) {
      store.set("otpCountDown", count);
      updateTimeoutId();
    } else {
      clearTimeout(window.otpTimeoutID);
      return store.remove("otpCountDown");
    }
  }, [count]);

  const updateTimeoutId = () => {
    let newTimeoutID = setTimeout(() => {
      setCount(count - 1);
    }, 1000);
    window.otpTimeoutID = newTimeoutID;
    setTimeoutID(window.otpTimeoutID);
  };

  const handleLocationCode = (e) => {
    setLocationCode(e.target.value);
  };

  const validateLocPhone = (value) => {
    if (locationCode === "852") {
      if (value.length === 8 && !/\D/.test(value)) {
        setInvalidPhoneLength(false);
      } else {
        setInvalidPhoneLength(true);
      }
    } else if (locationCode === "86") {
      if (value.length === 11 && !/\D/.test(value)) {
        setInvalidPhoneLength(false);
      } else {
        setInvalidPhoneLength(true);
      }
    }
  };

  const handlePhoneNum = (e) => {
    let value = e.target.value;
    setPhoneNum(e.target.value);
    validateLocPhone(value);
    // value.length !== 8 ? setInvalidPhone(true) : setInvalidPhone(false);
  };

  const handlePassword = (e) => {
    let value = e.target.value;
    setPwd(value);
  };

  const handleConfirmPassword = (e) => {
    let value = e.target.value;
    setConfirmPwd(value);
  };

  const handleOtp = (e) => {
    if (e.target.value.length > 0) {
      setOtp(e.target.value);
      setInvalidOtp(false);
    } else setInvalidOtp(true);
  };

  // Fetch getVerificationCode
  const handleGetCode = () => {
    if (invalidPhone) {
      return setErrModalMsg("格式錯誤");
    } else if (!phoneNum) return setErrModalMsg("請輸入手機號碼");
    setIsOTPloading(true);

    /* Dummy Code Testing */
    // setInvalidPhone(false);
    // setIsOTPloading(false);
    // setCount(60);
    // window.sessionStorage.setItem("sessionReference", 1);
    // setTimeout(() => {
    //   alert(`驗證碼: ${test_otp}`);
    // }, 3000);
    ////////////////////////////////////////////////////

    api
      .forgetPasswordOTP(locationCode, phoneNum)
      .then((res) => {
        if (res && res.response.code === "200") {
          setInvalidPhone(false);
          setIsOTPloading(false);
          setCount(60);

          // on refresh still countinue countdown
          window.sessionStorage.setItem("sessionReference", 1);
        } else if (res.response.code === "400") {
          setInvalidPhone(true);

          if (res.payload.error_code === "4535") {
            setErrModalMsg(t("forgetPwd_userNotExits_msg"));
          } else {
            setConsoleMsg(res.payload.error_message);
            console.log(res.response.payload);
          }
        }
      })
      .catch((err) => {
        setConsoleMsg(t("errMsg_networkErr"));
        console.log(err);
      })
      .finally(() => {
        setIsOTPloading(false);
      });
  };

  const handleReset = () => {
    /* Dummy Code Testing */
    // if (otp !== test_otp) {
    //   setInvalidOtp(true);
    // } else {
    //   setIsLoading(true);
    //   setReset(true);
    //   setBtnDisabled(true);
    //   setIsLoading(false);
    // }
    ////////////////////////////////////////
    if (!phoneNum) return setErrModalMsg("請輸入手機號碼");
    if (!otp) return setErrModalMsg(t("forgetPwd_input_placeholder"));

    setIsLoading(true);

    api
      .CheckOtpStatus(locationCode, phoneNum, otp)
      .then((res) => {
        if (res && res.response.code === "200") {
          setReset(true);
        } else if (res.response.code === "400") {
          if (res.payload.error_code === "4201") {
            setInvalidOtp(true);
          } else {
            setConsoleMsg(res.payload.error_message);
            console.log(res.response.payload);
          }
        }
      })
      .catch((err) => {
        setConsoleMsg(t("errMsg_networkErr"));
        console.log(err);
      })
      .finally(() => {
        setBtnDisabled(true);
        setIsLoading(false);
      });
  };

  const handleConfirmReset = () => {
    /* Dummy Code Testing */
    // if (invalidPwd) return;
    // store.set("newPwd", pwd);
    // navigate("/");
    ////////////////////////////////////

    if (matchPwd) {
      setIsLoading(true);

      api
        .resetPassword(locationCode, phoneNum, otp, pwd)
        .then((res) => {
          if (res && res.response.code === "200") {
            setErrModalMsg(t("forgetPwd_msg"));
          } else if (res.response.code === "400") {
            if (res.payload.error_code === "4201") {
              setInvalidOtp(true);
            } else {
              setConsoleMsg(res.payload.error_message);
              console.log(res.response.payload);
            }
          }
        })
        .catch((err) => {
          setConsoleMsg(t("errMsg_networkErr"));
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleCloseErrModal = () => {
    if (errModalMsg === t("forgetPwd_msg")) {
      navigate("/");
    } else {
      setErrModalMsg(null);
      setConsoleMsg(null);
    }
  };

  return (
    <>
      <div className="content noselect">
        <div className="marginContent">
          <div className="backBtnDiv">
            <GoBackBtn color={`${config.theme.color}`} path="/" />
          </div>

          <div style={{ marginTop: "50px" }}>
            <h2 className={styles.title}>
              {reset ? t("forgetPwd_resetBtn_label") : t("forgetPwd_title")}
            </h2>
          </div>

          {!reset ? (
            <>
              <label style={{ alignItems: "left" }}>
                {t("home_phone_input_label")}
              </label>

              <FormControl className={styles.form}>
                <NativeSelect
                  value={locationCode}
                  onChange={(e) => handleLocationCode(e)}
                  name="locationCode"
                  className={styles.locationCode}
                  // style={{
                  //   borderBottom: invalidLocation
                  //     ? "1.5px solid #f44336"
                  //     : "initial",
                  // }}
                >
                  <option value={852}>852</option>
                  <option value={86}>86</option>
                </NativeSelect>

                <TextField
                  variant="standard"
                  type="tel"
                  inputMode="tel"
                  className={styles.fullTextLength}
                  placeholder={t("home_phone_input_placeholder")}
                  error={invalidPhone}
                  onChange={(e) => handlePhoneNum(e)}
                />
                <VerifyCodeBtn
                  page="home"
                  handleGetCode={handleGetCode}
                  count={count}
                  otpLoading={isOTPloading}
                  t={t}
                  config={config}
                />
              </FormControl>

              <label>{t("forgetPwd_otp_label")}</label>
              <FormControl className={`${styles.form} ${styles.verfiyForm}`}>
                <TextField
                  variant="standard"
                  type="text"
                  className={styles.fullTextLength}
                  placeholder={t("forgetPwd_input_placeholder")}
                  onChange={(e) => handleOtp(e)}
                  style={{
                    width: "100%",
                    borderBottom: invalidOtp ? "#D46666" : "#cacaca",
                  }}
                />
              </FormControl>
              {invalidOtp && (
                <p
                  style={{
                    fontSize: "14px",
                    marginTop: "-10px",
                    color: "#e11111",
                  }}
                >
                  {t("forgetPwd_invalidOtp_msg")}
                </p>
              )}
            </>
          ) : (
            <>
              {/* Password */}
              <label>{t("forgetPwd_newPwd_label")}</label>
              <Input
                type={showPwd ? "text" : "password"}
                className={styles.fullTextLength}
                placeholder={t("forgetPwd_newPwd_placeholder")}
                onChange={(e) => handlePassword(e)}
                style={{
                  width: "100%",
                  marginBottom: "20px",
                  borderBottom: invalidPwd ? "#D46666" : "#cacaca",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPwd(!showPwd)}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {showPwd ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {/* <TextField
                variant="standard"
                type="password"
                className={styles.fullTextLength}
                placeholder={t("forgetPwd_newPwd_placeholder")}
                onChange={(e) => handlePassword(e)}
                style={{
                  width: "100%",
                  marginBottom: "20px",
                  borderBottomColor: invalidPwd ? "#D46666" : "#cacaca",
                }}
              /> */}

              {/* Confirm Password */}
              <label>{t("forgetPwd_confirmNewPwd_label")}</label>
              <Input
                type={showConfirmPwd ? "text" : "password"}
                className={styles.fullTextLength}
                placeholder={t("forgetPwd_confirmNewPwd_placeholder")}
                onChange={(e) => handleConfirmPassword(e)}
                style={{
                  width: "100%",
                  borderBottom: invalidPwd ? "#D46666" : "#cacaca",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {showConfirmPwd ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {/* <TextField
                variant="standard"
                type="password"
                className={styles.fullTextLength}
                placeholder={t("forgetPwd_confirmNewPwd_placeholder")}
                onChange={(e) => handleConfirmPassword(e)}
                style={{
                  width: "100%",
                  borderBottomColor: !matchPwd ? "#D46666" : "#cacaca",
                }}
              /> */}
              {!matchPwd && (
                <p style={{ fontSize: "14px", color: "#e11111" }}>
                  {t("forgetPwd_mismatchPwd_msg")}
                </p>
              )}
              <p
                style={{
                  fontSize: "14px",
                  // color: "#999999",
                  color: invalidPwd ? "#e11111" : "#999999",
                }}
              >
                {t("home_pwd_hints")}
              </p>
            </>
          )}

          <button
            className="colorBtn fetch"
            disabled={btnDisabled}
            style={{
              backgroundColor: btnDisabled
                ? "#888888"
                : CustomConfig.theme.color,
            }}
            onClick={reset ? handleConfirmReset : handleReset}
          >
            {isLoading ? (
              <Loading color={"#ffffff"} />
            ) : reset ? (
              `${t("forgetPwd_confirmResetBtn_label")}`
            ) : (
              `${t("forgetPwd_resetBtn_label")}`
            )}
          </button>
        </div>
      </div>

      <ErrorModal
        openModal={errModalMsg || consoleMsg ? true : false}
        errorMsg={errModalMsg}
        consoleMsg={consoleMsg}
        handleCloseModal={handleCloseErrModal}
        t={t}
        config={config}
      />
    </>
  );
}
